import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { isGitflicAvailable } from '../hooks';

export const entityGitflicPipelinesCard = EntityCardBlueprint.make({
  name: 'pipelines',
  params: {
    filter: isGitflicAvailable,
    loader: () =>
      import('../components/GitflicPipelinesCard').then(m => (
        <m.GitflicPipelinesCard />
      )),
  },
});
